var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shouldShowWebPhone
    ? _c(
        "div",
        {
          staticClass: "webphone-container",
          class: {
            "webphone-minimized": _vm.isMinimized,
            "webphone-maximized": !_vm.isMinimized,
            "webphone-dragging": _vm.isDragging,
            shouldShowContactOverlay:
              _vm.shouldShowContactOverlay &&
              !_vm.isContactOverlayCollapsed &&
              !_vm.isMinimized &&
              _vm.foundContacts.length > 0,
          },
          style: _vm.minimizedStyle,
        },
        [
          _vm.isMinimized
            ? _c(
                "div",
                {
                  staticClass: "webphone-minimized-button",
                  class: {
                    "status-connected":
                      _vm.sipStatus.isRegistered && !_vm.isOnBreak,
                    "status-on-break": _vm.isOnBreak,
                    "status-calling": _vm.callState.status === "calling",
                    "status-ringing": _vm.callState.status === "ringing",
                    "incoming-call": _vm.callState.status === "incoming",
                  },
                  on: { mousedown: _vm.startDrag },
                },
                [
                  _c("div", { staticClass: "status-indicator" }),
                  _vm._v(" "),
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.getMinimizedIcon()) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.callState.status === "incoming"
                    ? _c("div", { staticClass: "incoming-call-info" }, [
                        _c("div", { staticClass: "caller-name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.callState.callerName ||
                                _vm.callState.callerNumber
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "webphone-maximized-wrapper",
                  style: _vm.maximizedWrapperStyle,
                },
                [
                  _c("WebPhoneContactOverlay", {
                    ref: "contactOverlay",
                    staticClass: "contact-overlay-left",
                    class: { collapsed: _vm.isContactOverlayCollapsed },
                    attrs: {
                      "phone-number": _vm.getActivePhoneNumber(),
                      "is-visible": _vm.shouldShowContactOverlay,
                      "is-collapsed": _vm.isContactOverlayCollapsed,
                    },
                    on: { "contacts-updated": _vm.handleContactsUpdated },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "webphone-maximized-content" }, [
                    _c(
                      "div",
                      {
                        staticClass: "webphone-header",
                        on: { mousedown: _vm.startDragMaximized },
                      },
                      [
                        _c("div", { staticClass: "header-left" }, [
                          _c(
                            "div",
                            {
                              staticClass: "status-dropdown",
                              class: { open: _vm.isStatusDropdownOpen },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "status-display",
                                  class: {
                                    connected:
                                      _vm.sipStatus.isRegistered &&
                                      !_vm.isOnBreak,
                                    "on-break": _vm.isOnBreak,
                                    disconnected:
                                      !_vm.sipStatus.isRegistered &&
                                      !_vm.isOnBreak,
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.toggleStatusDropdown.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "status-dot" }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.getStatusText())),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "i",
                                    {
                                      staticClass:
                                        "material-icons dropdown-arrow",
                                    },
                                    [_vm._v("keyboard_arrow_down")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.isStatusDropdownOpen
                                ? _c("div", { staticClass: "dropdown-menu" }, [
                                    _vm.sipStatus.isRegistered && !_vm.isOnBreak
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dropdown-item break-option",
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.goToBreakMode.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("div", {
                                              staticClass: "status-dot break",
                                            }),
                                            _vm._v(" "),
                                            _c("span", [_vm._v("Molaya Al")]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isOnBreak
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dropdown-item online-option",
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.goOnline.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "status-dot connected",
                                            }),
                                            _vm._v(" "),
                                            _c("span", [_vm._v("Online Ol")]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", { staticClass: "header-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "minimize-btn",
                              on: { click: _vm.toggleMode },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("remove"),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "webphone-tabs",
                        class: { disabled: _vm.isOnBreak },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "tab-btn",
                            class: {
                              active: _vm.activeTab === "dialer",
                              disabled: _vm.isOnBreak,
                            },
                            attrs: { disabled: _vm.isOnBreak },
                            on: {
                              click: function ($event) {
                                !_vm.isOnBreak && (_vm.activeTab = "dialer")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("dialpad"),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("Tuş Takımı")]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "tab-btn",
                            class: {
                              active: _vm.activeTab === "history",
                              disabled: _vm.isOnBreak,
                            },
                            attrs: { disabled: _vm.isOnBreak },
                            on: {
                              click: function ($event) {
                                !_vm.isOnBreak && (_vm.activeTab = "history")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("history"),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("Geçmiş")]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "tab-btn",
                            class: {
                              active: _vm.activeTab === "contacts",
                              disabled: _vm.isOnBreak,
                            },
                            attrs: { disabled: _vm.isOnBreak },
                            on: {
                              click: function ($event) {
                                !_vm.isOnBreak && (_vm.activeTab = "contacts")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("contacts"),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("Dahililer")]),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "webphone-content",
                        class: { disabled: _vm.isOnBreak },
                      },
                      [
                        _vm.isOnBreak
                          ? _c("div", { staticClass: "break-mode-overlay" }, [
                              _vm._m(1),
                              _vm._v(" "),
                              _c("h3", [_vm._v("Mola Modundasınız")]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "Web telefonu kullanmak için online olmanız gerekiyor."
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "online-button",
                                  on: { click: _vm.goOnline },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("play_arrow"),
                                  ]),
                                  _vm._v(
                                    "\n                        Online Ol\n                    "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.activeTab === "dialer" && !_vm.isOnBreak
                          ? _c("WebPhoneDialer", {
                              ref: "dialerComponent",
                              attrs: {
                                "call-state": _vm.callState,
                                "dial-number": _vm.dialNumber,
                                "sip-status": _vm.sipStatus,
                                extensions: _vm.extensions,
                                mapping: _vm.$_.get(
                                  _vm.netGsmChannel,
                                  "payload.mapping",
                                  {}
                                ),
                              },
                              on: {
                                dial: _vm.handleDial,
                                call: _vm.handleCall,
                                hangup: _vm.handleHangup,
                                answer: _vm.handleAnswer,
                                reject: _vm.handleReject,
                                mute: _vm.handleMute,
                                hold: _vm.handleHold,
                                transfer: _vm.handleTransfer,
                                dtmf: _vm.handleDTMF,
                                "number-change": function ($event) {
                                  _vm.dialNumber = $event
                                },
                                "play-dtmf-tone": function ($event) {
                                  return _vm.playDTMFTone($event)
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shouldShowContactOverlay &&
                        _vm.foundContacts.length > 0
                          ? _c(
                              "div",
                              {
                                ref: "contactToggleButton",
                                staticClass: "contact-overlay-toggle-container",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "toggle-button",
                                    on: {
                                      click: function () {
                                        return (_vm.isContactOverlayCollapsed =
                                          !_vm.isContactOverlayCollapsed)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isContactOverlayCollapsed
                                            ? "visibility"
                                            : "visibility_off"
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isContactOverlayCollapsed
                                            ? "Kişileri Göster"
                                            : "Kişileri Gizle"
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "contact-count" },
                                      [_vm._v(_vm._s(_vm.foundContacts.length))]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.activeTab === "history" && !_vm.isOnBreak
                          ? _c("WebPhoneCallHistory", {
                              attrs: { "call-history": _vm.callHistory },
                              on: {
                                call: _vm.handleCallFromHistory,
                                "clear-history": _vm.clearCallHistory,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.activeTab === "contacts" && !_vm.isOnBreak
                          ? _c("WebPhoneContacts", {
                              attrs: {
                                extensions: _vm.extensions,
                                mapping: _vm.$_.get(
                                  _vm.netGsmChannel,
                                  "payload.mapping",
                                  {}
                                ),
                                "call-state": _vm.callState,
                              },
                              on: {
                                call: _vm.handleCallFromContacts,
                                "refresh-contacts": _vm.handleRefreshExtensions,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
          _vm._v(" "),
          _vm.isMinimized && _vm.callState.status === "incoming"
            ? _c("div", { staticClass: "incoming-call-notification" }, [
                _c("div", { staticClass: "caller-info" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "caller-details" }, [
                    _c("div", { staticClass: "caller-name" }, [
                      _vm._v(_vm._s(_vm.callState.callerName || "Bilinmeyen")),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "caller-number" }, [
                      _vm._v(_vm._s(_vm.callState.callerNumber)),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "call-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "answer-btn",
                      on: { click: _vm.handleAnswer },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("call"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "reject-btn",
                      on: { click: _vm.handleReject },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("call_end"),
                      ]),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("audio", {
            ref: "remoteAudio",
            attrs: { autoplay: "", volume: 1.0, muted: false },
          }),
          _vm._v(" "),
          _c("audio", { ref: "ringtone", attrs: { loop: "" } }, [
            _c("source", {
              attrs: {
                src: "https://upload.wikimedia.org/wikipedia/commons/transcoded/3/34/Sound_Effect_-_Door_Bell.ogg/Sound_Effect_-_Door_Bell.ogg.mp3",
                type: "audio/mpeg",
              },
            }),
          ]),
          _vm._v(" "),
          _c("audio", { ref: "ringbacktone", attrs: { loop: "" } }, [
            _c("source", {
              attrs: {
                src: "https://bigsoundbank.com/UPLOAD/mp3/1617.mp3",
                type: "audio/mpeg",
              },
            }),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-center" }, [
      _c("h3", [_vm._v("Supsis Web Phone")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "break-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("coffee")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caller-avatar" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("person")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }